/**
 * FitModule — admin OS surface for the /fit pillar.
 *
 * Wellness, dawn classes, trainer pairings, spa programmes.
 */
import React from "react";
import Placeholder from "@/pages/admin/os/Placeholder";

export default function FitModule() {
  return (
    <Placeholder
      title="Fit · Admin"
      phase="Phase 2"
      testid="os-modules-fit"
      description="Wellness venues the Concierge® uses · dawn classes, trainer pairings, spa programmes. Brief queue is in Operate → Requests."
      willInclude={[
        "Signature Wellness CRUD (yoga retreats, pilates studios, longevity clinics)",
        "Trainer roster per city · paired bookings",
        "Walks loop catalogue (folded into /fit per founder spec)",
        "Fit brief queue & confirmation pipeline",
      ]}
    />
  );
}
